import { render, staticRenderFns } from "./AdminCambioNiveles.vue?vue&type=template&id=eaafe0d4&"
import script from "./AdminCambioNiveles.vue?vue&type=script&lang=js&"
export * from "./AdminCambioNiveles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports